// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_splice_call from "rescript/lib/es6/caml_splice_call.js";

function DoubleHorBarChart(Props) {
  var data = Props.data;
  var wideLabelOpt = Props.wideLabel;
  var wideLabel = wideLabelOpt !== undefined ? wideLabelOpt : false;
  var places = Belt_Array.map(data, (function (param) {
          return param[2];
        }));
  var maxPlace = Caml_splice_call.spliceApply(Math.max, [places]);
  var minPlace = Caml_splice_call.spliceApply(Math.min, [places]);
  var lowPlace = maxPlace + 0.2;
  var placeRange = lowPlace - minPlace;
  var prs = Belt_Array.map(data, (function (param) {
          return param[1];
        }));
  var minPr = Caml_splice_call.spliceApply(Math.min, [prs]);
  var maxPr = Caml_splice_call.spliceApply(Math.max, [prs]);
  var lowPr = minPr * 0.5;
  var prRange = maxPr - lowPr;
  return React.createElement("div", {
              className: "flex flex-col text-xs gap-[10px] leading-none w-[173px]"
            }, Belt_Array.map(data, (function (param) {
                    var pl = param[2];
                    var pr = param[1];
                    var label = param[0];
                    return React.createElement("div", {
                                key: label,
                                className: "flex items-center"
                              }, React.createElement("div", {
                                    className: "text-sm font-medium flex-shrink-0 " + (
                                      wideLabel ? "w-4" : "w-2"
                                    )
                                  }, label), React.createElement("div", {
                                    className: "text-xs leading-none"
                                  }, React.createElement("div", {
                                        className: "flex items-center"
                                      }, React.createElement("div", {
                                            className: "ml-[8px] mr-[7px] h-[10px] bg-secondary-9",
                                            style: Global.s({
                                                  width: ((pr - lowPr) / prRange * 110).toFixed() + "px"
                                                })
                                          }), React.createElement("div", undefined, Global.formatPct2(undefined, pr))), React.createElement("div", {
                                        className: "flex items-center mt-1"
                                      }, React.createElement("div", {
                                            className: "ml-[8px] mr-[7px] h-[10px] bg-primary-11",
                                            style: Global.s({
                                                  width: ((lowPlace - pl) / placeRange * 110).toFixed() + "px"
                                                })
                                          }), React.createElement("div", undefined, Global.toFixed(undefined, pl)))));
                  })));
}

var make = DoubleHorBarChart;

export {
  make ,
  
}
/* react Not a pure module */
